module.exports = __webpack_public_path__ + "img/youbube.acaf3ab.svg";